module.exports = __webpack_public_path__ + "img/zgjqrwang.5048f4da.png";